import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Avatar, Badge, Box, Button, Theme, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

import contactBubbleImg from '../../../assets/images/contact-bubble.svg'

interface StyledProps {
  $isExpanded?: boolean
  $isChatOpened?: boolean
  $small?: boolean
}

export const ChatPanelWrapper = styled('div')<StyledProps>`
  background-color: ${colors.primary};
  width: ${props => (props.$isExpanded || !props.$small ? '100%' : '200px')};
  height: 50px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  flex: 0 0 auto;
  border-radius: 8px 8px 0 0;
`

export const ChatModalWrapper = styled('div')<StyledProps>`
  width: ${props => (props.$isExpanded || !props.$small ? '365px' : '200px')};
  height: 100%;
  max-height: ${props => (props.$isExpanded ? '700px' : '50px')};
  background-color: #ffffff;
  position: fixed;
  overflow: hidden;
  bottom: 0;
  right: ${(props: { theme: Theme }) => props.theme.spacing(2)};
  border-top-left-radius: ${(props: { theme: Theme }) => props.theme.spacing(1)};
  border-top-right-radius: ${(props: { theme: Theme }) => props.theme.spacing(1)};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  z-index: 1000;
  flex-direction: column;
  border-radius: ${(props: { $isChatOpened?: boolean; theme: Theme }) =>
    props.$isChatOpened ? props.theme.spacing(1) : `${props.theme.spacing(1)} ${props.theme.spacing(1)} 0 0`};
`

export const ChatModalInner = styled('div')<{ $reverse?: boolean }>`
  padding: 16px 0 16px 16px;
  display: flex;
  flex-direction: ${props => (props.$reverse ? 'column-reverse' : 'column')};
  justify-content: space-between;
  max-width: 355px;
  overflow-y: auto;
  flex: 1 1 auto;
  height: 100%;
`

export const MessageListContainer = styled('div')`
  position: relative;
`

export const MessageWrapper = styled('div')`
  padding-bottom: 12px;
`

export const RotatedArrowIcon = styled(KeyboardArrowUpIcon)`
  transition: transform 0.3s ease;

  &.expanded {
    transform: rotate(180deg);
  }
`

export const StyledDragIcon = styled(DragIndicatorIcon)`
  user-select: none !important;
  color: #ffffff;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
` as unknown as typeof DragIndicatorIcon

export const StyledBadge = styled(Badge)`
  .MuiBadge-badge {
    background: #ff4c4c;
    width: 11px;
    height: 11px;
    border-radius: 50%;
  }
`

export const MailIconBadgeWrapper = styled('div')`
  margin-right: ${(props: { theme: Theme }) => props.theme.spacing(1)};
`

export const StyledTypography = styled(Typography)`
  color: #ffffff;
`

export const NoMessagesContainer = styled('div')`
  margin-top: 40px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const EmptyChatImageComponent = styled('img')`
  margin: 40px 0;
`

export const BackButton = styled(Button)`
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #fff;
  background: transparent;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  margin-right: 16px;
  text-transform: none;
`

export const ChatAvatarWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex: 0 0 auto;
  overflow: hidden;
  background-color: #f4f4f4;
  box-shadow: -1px 0 4px rgba(0, 0, 0, 0.15);
  color: ${colors.bodyText};
  border-radius: 50%;
  font-size: 20px;
  font-weight: 500;
  text-transform: uppercase;

  & svg {
    font-size: 47px;
  }
`

export const ChatDate = styled('div')`
  font-size: 10px;
  font-weight: 400;
  min-width: 40px;
  flex: 0 0 auto;
`

export const ChatMessageInputWrapper = styled('div')`
  position: relative;
  width: 100%;
  background-color: ${colors.commonGrey};
  padding-top: 16px;
  /* height: 300px; */

  & .quill {
    display: flex;
    flex-direction: column-reverse;
  }

  & .ql-editor {
    padding: 11px 15px;
  }

  & .ql-toolbar.ql-snow {
    order: 1;
    border-radius: 4px;
    border: 1px solid #e7e7e7;
    background: #fff;
    margin: 16px;
    padding: 0;
    background: none;
    border: none;
  }

  & .ql-container.ql-snow {
    order: 2;
    border-radius: 4px;
    border: 1px solid #e7e7e7;
    background: #fff;
    margin: 0 16px;
    max-height: 200px;
    overflow-y: auto;
  }

  & .ql-formats button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    background-color: #fff;
    border: 1px solid ${colors.lightGrey};
  }
`

export const ClearInputContainer = styled('div')`
  position: absolute;
  bottom: 66px;
  right: 20px;
`

export const SortByWrapper = styled('button')`
  background: none;
  border: none;
  padding: 0;
`

export const SubmitMessageButtonWrapper = styled('div')`
  position: absolute;
  bottom: 12px;
  right: 20px;
`

export const UnreadCountBadge = styled(Badge)`
  min-height: 13px;
  min-width: 13px;
  color: #fff;
  padding: 0 5px;
  background-color: ${colors.primary};
  border-radius: 50px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DateDividerWrapper = styled('div')`
  padding: 16px 0;
  margin-bottom: 10px;
  position: relative;
`

export const DateDividerDate = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 8px;
  background-color: #fff;
`

export const LoadMoreMessagesAnchor = styled('div')`
  position: absolute;
  top: 100px;
`

export const AttendeeItemWrapper = styled('div')`
  display: flex;
  align-items: center;
  padding-bottom: 13px;
  cursor: pointer;
`

export const AttendeeAvatar = styled(Avatar)`
  width: 46px;
  height: 46px;
  background-color: #f4f4f4;
  box-shadow: -1px 0 4px rgba(0, 0, 0, 0.15);
  color: ${colors.bodyText};
  border-radius: 50%;
  font-size: 20px;
  font-weight: 500;
  text-transform: uppercase;

  & svg {
    font-size: 46px;
  }
`

export const OpenedChatInfoWrapper = styled('div')<{ $isDisabled?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;

  ${(props: { $isDisabled?: boolean }) =>
    props.$isDisabled
      ? `
          cursor: auto;
          pointer-events: none;
          opacity: 0.2;
        `
      : ''};
`

export const ContactedBubbleWrapper = styled('div')`
  position: relative;
  width: fit-content;
`

export const ContactedBubbleIcon = styled('div')`
  position: absolute;
  right: -16px;
  top: -10px;
  z-index: 10;
  width: 24px;
  height: 24px;

  background-image: url(${contactBubbleImg});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const ChatPreviewAvatarContainer = styled(Box)<{ $isDisabledStyle?: boolean }>`
  position: relative;
  ${props =>
    props.$isDisabledStyle
      ? `
          opacity: 0.2;
        `
      : ''};
`

export const ChatPreviewContentContainer = styled(Box)<{ $isDisabledStyle?: boolean }>`
  ${props =>
    props.$isDisabledStyle
      ? `
          opacity: 0.2;
        `
      : ''};
`

export const DefaultCompanyLogoBadgeWrapper = styled('div')`
  position: absolute;
  top: -6px;
  right: 3px;
  font-size: 21px;
`
